"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

var _errors = require("../errors.js");

var _log = _interopRequireDefault(require("../log.js"));

var _axios = _interopRequireDefault(require("../axios.js"));

var _ampConfig = _interopRequireDefault(require("../amp-config.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var slidesService = new _GatewayService["default"]('slides-services');

var copyGoogleSlidesPresentation = function copyGoogleSlidesPresentation(presentationId, unitKey, chapterKey, unitRevision, lessonKey, edition, extraParams) {
  if (_lodash["default"].isEmpty(presentationId)) {
    _log["default"].error('Presentation not copied because presentationId was not specified');

    return Promise.reject((0, _errors.missingParam)('presentationId'));
  }

  if (_lodash["default"].isEmpty(unitKey)) {
    _log["default"].error('Presentation not copied because unitKey was not specified');

    return Promise.reject((0, _errors.missingParam)('unitKey'));
  }

  if (_lodash["default"].isEmpty(chapterKey)) {
    _log["default"].error('Presentation not copied because chapterKey was not specified');

    return Promise.reject((0, _errors.missingParam)('chapterKey'));
  }

  if (_lodash["default"].isEmpty(unitRevision)) {
    _log["default"].error('Presentation not copied because unitRevision was not specified');

    return Promise.reject((0, _errors.missingParam)('unitRevision'));
  }

  if (_lodash["default"].isEmpty(lessonKey)) {
    _log["default"].error('Presentation not copied because lessonKey was not specified');

    return Promise.reject((0, _errors.missingParam)('lessonKey'));
  }

  if (_lodash["default"].isEmpty(edition)) {
    _log["default"].error('Presentation not copied because edition was not specified');

    return Promise.reject((0, _errors.missingParam)('edition'));
  }

  var body = Object.assign({}, {
    unitKey: unitKey,
    chapterKey: chapterKey,
    unitRevision: unitRevision,
    lessonKey: lessonKey,
    edition: edition
  }, extraParams);
  return slidesService.post("v2/gdrive/files/".concat(presentationId, "/copy"), body);
};

var getGoogleAuthSlidesStatus = function getGoogleAuthSlidesStatus(redirectUrl) {
  if (_lodash["default"].isEmpty(redirectUrl)) {
    _log["default"].error('Google auth status not fetched because redirectUrl was not specified');

    return Promise.reject((0, _errors.missingParam)('redirectUrl'));
  }

  return slidesService.get("v2/google/auth?redirectUrl=".concat(redirectUrl));
};

var resetGoogleAuthSlidesStatus = function resetGoogleAuthSlidesStatus(ampId) {
  if (_lodash["default"].isEmpty(ampId)) {
    _log["default"].error('Google auth status not reset because ampId was not specified');

    return Promise.reject((0, _errors.missingParam)('ampId'));
  }

  return _ampConfig["default"].get('gateway').then(function (gateway) {
    return _axios["default"]["delete"]("".concat(gateway, "/user-storage-service/storagev3/").concat(ampId, "/google-auth"));
  });
};

var _default = {
  copyGoogleSlidesPresentation: copyGoogleSlidesPresentation,
  getGoogleAuthSlidesStatus: getGoogleAuthSlidesStatus,
  resetGoogleAuthSlidesStatus: resetGoogleAuthSlidesStatus
};
exports["default"] = _default;